export default [
  {
    path: '/openingSupplyEntry/:key?',
    name: 'openingSupplyEntry',
    component: () => import('@/views/openingSupplyEntry/OpeningSupplyEntry.vue'),
    meta: {},
  },
];
